<template>
    <div class="slidePic">
        <!-- <van-swipe indicator-color="#FD2840" :autoplay="3000"  >
            <van-swipe-item v-for="(item, index) in content" :key="index">
                <router-link :to="'/'+item.url.name+'?id='+item.url.query.id">
                <img :src="item.pic_url" alt="">
                </router-link>
            </van-swipe-item> 
        </van-swipe>--> 
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
                <img src="../../assets/images/pic-index-banner1.png" alt="" srcset="">
            </van-swipe-item>
            <van-swipe-item>
                <img src="../../assets/images/pic-index-banner1.png" alt="" srcset="">
            </van-swipe-item>
             
        </van-swipe>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Swipe, SwipeItem } from 'vant';
    Vue.use(Swipe);
    Vue.use(SwipeItem);
    export default {
        name: "SlidePics",
        components: {
            Swipe, SwipeItem
        },
        props: {
            content: {
                type: Array,
                default: [],
            },

            top: {
                type: String,
                default: '',
            }

        },

        data: function () {
            return {
                duration: 300
            }
        },

        methods: {


        },

        filters: {}

    };
</script>

<style scoped>
.slidePic{width: 6.6rem;margin: 0 auto;}
 
    .van-swipe-item img { 
        width: 100%;
        border-radius: 5px;
    }
   

</style>


// WEBPACK FOOTER //
// SlidePics.vue?5adf6dc1